
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { isMobile } from '@/common/ts/common';

const baseUrl = '20220414NLXQP';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};
  beforeRouteEnter(to: any, from: any, next: any) {
    if (!isMobile()) {
      return (location.href =
        'https://activity.cqcb.com/shangyou_activity/2022NLXQPPC/');
    }
    next();
  }
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/webupload/o_1g0kba9t218iedd35pdk4q1stq7.jpg';
    // App分享
    this.$appShareInfo({
      title: '新征程上，努力向前跑——来自华溪村的报道',
      url: location.href,
      subtitle: `新征程上，努力向前跑——来自华溪村的报道`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '新征程上，努力向前跑——来自华溪村的报道',
        subtitle: `新征程上，努力向前跑——来自华溪村的报道`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    // 添加pv统计
    this.$addPv(0);
  }
}
